import React, { useState, useEffect } from 'react';
import { Icon, Pagination, Popconfirm } from 'antd';
import { fetchNodeRelation, deleteNodeRelation } from '../../../../api/inspiration';

const rows = Array.from(new Array(5).keys());
const cols = Array.from(new Array(7).keys());
const pageSize = 35;

export default React.memo(props => {
    const { isEditRelation, relationType, nodeInfo, setEditRelation, word, getSearchNode } = props;
    const [relations, setRelations] = useState([]);
    const [relationsCount, setRelationsCount] = useState(0);
    const [currentRelation, setCurrentRelation] = useState(1);

    useEffect(() => {
        if (nodeInfo) {
            getNodeRelation(relationType, nodeInfo.centerNodeTag.type, nodeInfo.centerNodeTag.id, 1);
        }
    }, [relationType, nodeInfo]);

    const getNodeRelation = async (relationType, tagType, centerNodeTagId, page) => {
        const result = await fetchNodeRelation({
            relationType,
            tagType,
            centerNodeTagId,
            page,
            pageSize
        });

        if (result?.error?.code == 0 && result.data?.relations?.length > 0) {
            setRelations(result.data.relations);
            setCurrentRelation(page);
            setRelationsCount(result.data.totalCount);
        } else {
            setRelations([]);
            setCurrentRelation(1);
            setRelationsCount(1);
        }
    };

    const deleteRelation = async item => {
        const res = await deleteNodeRelation({
            tagType: nodeInfo.centerNodeTag.type,
            relationId: item.id
        });

        if (res?.error?.code == 0) {
            setEditRelation(false);
            getSearchNode(word);
        } else if (res?.error?.message) {
            message.error(res.error.message);
        } else {
            message.error("网络连接失败");
        }
    };

    const onPaginationChange = v => {
        getNodeRelation(relationType, nodeInfo.centerNodeTag.type, nodeInfo.centerNodeTag.id, v);
    };

    return (
        <div className='nodeManage_relation_detail_table'>
            <table border="1" width="100%" align="center">
                <thead width="100%" className='thead'>
                    <tr width="100%">
                        {
                            cols.map(v => <td width='14.2%' align="center" key={v}></td>)
                        }
                    </tr>
                </thead>
                
                <tbody width="100%">
                    {
                        rows.map(item => {
                            return (
                                <tr width="100%" key={item}>
                                    {
                                        cols.map(v => (
                                            <td align="center" key={v} className='edit_table_cell' width='14.2%'>
                                                {
                                                    relations[item * 7 + v] && (
                                                        <div className='edit_table_cell_content'>
                                                            <span>{relations[item * 7 + v].word}</span>
                                                            <Popconfirm
                                                                title="确定删除该节点关系吗？"
                                                                onConfirm={() => deleteRelation(relations[item * 7 + v])}
                                                                okText="确定"
                                                                cancelText="取消"
                                                            >
                                                                <Icon className={`delete_icon ${isEditRelation && 'delete_icon_show'}`} type="close"
                                                                                style={{ fontSize: '16px', color: '#333', position: 'absolute', right: '5px', top: '5px' }} />
                                                            </Popconfirm>
                                                        </div>
                                                    )
                                                }                                                                
                                            </td>
                                        ))
                                    }
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
            <Pagination current={currentRelation} onChange={onPaginationChange} total={relationsCount} pageSize={pageSize} />
        </div>
    );
}, (prev, next) => {
    return prev.relationType === next.relationType && prev.nodeInfo === next.nodeInfo && prev.word === next.word && prev.isEditRelation === next.isEditRelation;
});